import {dataIsValidAfterDelete, dataIsValidAfterSave} from '../constants';
import {CHANGE_REQUESTED_DATA_VALIDITY} from './types';

export const changeDataValidity = ({resource, payload}) => ({
  type: CHANGE_REQUESTED_DATA_VALIDITY,
  resource,
  payload,
});

export const changeAllDataValidity = ({resource, payload}) => ({
  type: CHANGE_REQUESTED_DATA_VALIDITY,
  resource,
  payload: {[dataIsValidAfterDelete]: payload, [dataIsValidAfterSave]: payload},
});

export const changeAfterSaveDataValidity = ({resource, payload}) => ({
  type: CHANGE_REQUESTED_DATA_VALIDITY,
  resource,
  payload: {[dataIsValidAfterSave]: payload},
});

export const changeAfterDeleteDataValidity = ({resource, payload}) => ({
  type: CHANGE_REQUESTED_DATA_VALIDITY,
  resource,
  payload: {[dataIsValidAfterDelete]: payload},
});